import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import useWindowDims from "../hooks/WindowDims";
import HotelMap from "./HotelMap"
import { toggleMapReady } from '../reducers/MapReadySlice'
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Container } from 'react-bootstrap';
import { GridLoader, PropagateLoader } from "react-spinners";
const MapWidget = () => {
    const colors = useSelector((state) => state.colors.value)
    const mapReady = useSelector((state) => state.mapReady.value)
    const data = useSelector((state) => state.data.value)
    const [mapZoom, setMapZoom] = useState(13)
    const [mapCenter, setMapCenter] = useState([31.78, 35.20])
    const { width, height } = useWindowDims()
    const dispatch = useDispatch();



    return (
        <>
            < MapContainer center={mapCenter} zoom={mapZoom}
                // whenReady={() => dispatch(toggleMapReady(true))}
                zoomControl={true}
                scrollWheelZoom={true}
                wheelDebounceTime={100}
                wheelPxPerZoomLevel={100}
                updateWhenZooming={false}
                padding={[20, 20]}
                minZoom={8}
                sleep={true}
                sleepTime={750}
                wakeTime={750}
                sleepNote={true}
                hoverToWake={true}

            >
                <TileLayer
                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    // url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
                    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                  <HotelMap />
               
             

</MapContainer >
        </>
    )
}
export default MapWidget
